import { Component, OnInit, Input, NgModule, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { InfoB } from '@app/models/infobox';
import { CommonModule } from '@angular/common';
import { LinkModule } from '@app/directives/link.directive';

@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextComponent implements OnInit {
  _box: InfoB;

  @Input() set box(value) {
    this._box = value;
    this.cdr.markForCheck();
  }
  @Input() styleClasses: string | string[] | Set<string> | { [klass: string]: any; };
  @Input() customStyle: { [klass: string]: any; };
  @Input() isAreaHero: boolean;
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {

  }

}
@NgModule({
  declarations: [TextComponent],
  exports: [TextComponent],
  imports: [
    CommonModule,
    LinkModule,
  ]
})
export class TextInfoboxModule { }
